/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import otherRouters from './others.js'
import quizPublicationRouter from './QuizPublicationRouter.js'
import brandPublicationRouter from './BrandPublicationRouter.js'
import podcastPublicationRouter from './PodcastPublicationRouter.js'
import contentPublicationRouter from './ContentPublicationRouter.js'
// Main 页面
import MainModule from 'src/views/main/MainModule.vue'
import MainIndex from 'src/views/main/MainIndex.vue'
// 账号管理
const ProfilePage = resolve => require(['src/views/profile/Profile'], resolve)
// Editor
const EditorPage = resolve => require(['src/views/editor/EditorPage'], resolve)
const EditorMetaPage = resolve =>
  require(['src/views/editor/EditorMetaPage'], resolve)
const EditorCourse = resolve =>
  require(['src/views/editor/EditorCourse'], resolve)
// 付费套餐
const CreatePage = resolve => require(['src/views/create/CreatePage'], resolve)
// publication 层级的组件
const PublicationCreate = resolve =>
  require(['src/views/publication/PublicationCreate'], resolve)
const PublicationUpgrade = resolve =>
  require(['src/views/publication/PublicationUpgrade'], resolve)

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    ...otherRouters,
    {
      name: '创建课程文章',
      path: '/:pubType/:publicationId/edit/course/:articleId',
      component: EditorCourse,
    },
    {
      name: '创建文章',
      path: '/:pubType/:publicationId/edit/:articleId',
      component: EditorPage,
    },
    {
      name: '修改文章信息',
      path: '/:pubType/:publicationId/edit/meta/:articleId',
      component: EditorMetaPage,
    },
    {
      path: '/',
      component: MainModule,
      redirect: '/index',
      children: [
        // /profile
        {
          name: '个人中心',
          path: '/profile',
          component: ProfilePage,
        },
        {
          name: '升级题库小程序',
          path: '/quiz/:publicationId/upgrade',
          component: PublicationUpgrade,
        },
        {
          name: '升级杂志小程序',
          path: '/content/:publicationId/upgrade',
          component: PublicationUpgrade,
        },
        {
          name: '升级品牌小程序',
          path: '/brand/:publicationId/upgrade',
          component: PublicationUpgrade,
        },
        {
          name: '升级播客小程序',
          path: '/podcast/:publicationId/upgrade',
          component: PublicationUpgrade,
        },
        // /index
        {
          name: '轻芒小程序+',
          path: '/index',
          component: MainIndex,
        },
        // /create
        {
          name: '创建小程序',
          path: '/create',
          component: CreatePage,
        },
        {
          name: '创建小程序类型',
          path: '/create/:publicationType',
          component: PublicationCreate,
        },
        // 内容小程序的 router
        contentPublicationRouter,
        // 答题小程序的 router
        quizPublicationRouter,
        // 品牌小程序的 router
        brandPublicationRouter,
        // 播客小程序的 router
        podcastPublicationRouter,
        // 兼容老路由
        {
          path: '/publication/:publicationId/',
          redirect: '/content/:publicationId/',
        },
        {
          path: '/publication/:publicationId/publish',
          redirect: '/content/:publicationId/publish',
        },
      ],
    },
    {
      path: '/*',
      redirect: '/index',
    },
  ],
})

export default router
